export default __webpack_public_path__ + "static/media/vendor_story_2.d12a644e.svg";